import React from 'react'

interface Props {
    inputRef: React.RefObject<HTMLInputElement>
    value: string
    placeholder?: string
    disabled?: boolean
    onOpen(): void
    onChange(value: string): void
    onBlur(): void
    testId: string
}

/**
 *
 */
const SearchableField = ({
    inputRef,
    value,
    placeholder,
    disabled,
    onOpen,
    onChange,
    onBlur,
    testId
}: Props): JSX.Element => {
    return (
        <input
            ref={inputRef}
            value={value}
            onFocus={onOpen}
            onClick={onOpen}
            onBlur={onBlur}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className='text-field input searchable-input-field'
            disabled={disabled}
            data-testid={testId}
            autoComplete='off'
        />
    )
}

export default SearchableField
